/* eslint-disable no-nested-ternary */
import styles from './ListMember.module.scss';

const ListMember = ({ memberData }) => {
  const addMember = () => {
    console.log('add member', memberData);
  };

  return (
    <>
      {memberData && (
        <div className={styles.listMemberWrapper}>
          <div className={styles.listMemberSecondWrapper}>
            <div
              className={styles.avatarWrapper}
              style={{ background: `center / cover no-repeat url(${memberData.avatar})` }}
            >
              <div className={styles.statusWrapper}>
                <div
                  className={
                    memberData.status === 'online'
                      ? styles.online
                      : memberData.status === 'offline'
                        ? styles.offline
                        : styles.busy
                  }
                />
              </div>
            </div>
            <div className={styles.name}>{memberData.name}</div>
          </div>
          {/* eslint-disable-next-line */}
          <img
            className={styles.addIcon}
            src="/images/templates/plus-icon-black.png"
            alt=""
            style={{ width: 20, height: 20 }}
            onClick={addMember}
          />
        </div>
      )}
    </>
  );
};

export default ListMember;
